import { Injectable } from '@angular/core';
import {
    HttpErrorResponse,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { from, tap } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private readonly keycloak: KeycloakService,
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): any {
        return from(this.handleAccess(req, next));
    }

    async handleAccess(req: HttpRequest<any>, next: HttpHandler) {
        if (req.url.startsWith('assets')) {
            //Find way around this
            return next.handle(req).toPromise();
        }
        const token: string = await this.keycloak.getToken();
        if (!token) {
            console.log('go to login');
            this.router.navigate(['login']);
            return;
        }
        const changedReq = req.clone({
            setHeaders: {
                Authorization: `bearer ${token}`,
            },
        });
        return next
            .handle(changedReq)
            .pipe(
                tap(
                    () => {},
                    (err: any) => {
                        if (err instanceof HttpErrorResponse) {
                            console.error(err);
                            /* if (err.status !== 401) {
                                return;
                            }
                            this.router.navigate(['/home']);*/
                        }
                    },
                ),
            )
            .toPromise();
    }
}
